import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import "./Ticket.css";
import "./menu3.css";
import TicketSidebar from "../components/TicketSidebar";
axios.defaults.withCredentials = true;

const Setting = () => {
  const [profileUser, setProfileUser] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const isEditPage = location.pathname.endsWith("/edit");
  const [error] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [notFound, setNotFound] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    position: "",
    phone: "",
    address: "",
    issueSummary: "",
    issueDetails: "",
    password: "",
    confirmPassword: "",
    fileupload: [],
    files: [],
    severityLevel: "",
    sla: "Platinum (7x24x4)",
  });

  const [profilePopup, setProfilePopup] = useState({
    show: false,
    type: "",
    title: "",
    message: "",
    redirectAfterClose: false,
  });
  const [confirmPopup, setConfirmPopup] = useState({
    show: false,
    title: "",
    message: "",
  });

  const showProfilePopup = ({
    type = "info",
    title = "",
    message = "",
    redirectAfterClose = false,
  }) => {
    setProfilePopup({
      show: true,
      type,
      title,
      message,
      redirectAfterClose,
    });
  };

  const closeProfilePopup = () => {
    const shouldRedirect = profilePopup.redirectAfterClose;

    setProfilePopup({
      show: false,
      type: "",
      title: "",
      message: "",
      redirectAfterClose: false,
    });

    if (shouldRedirect) {
      navigate("/customer/setting");
    }
  };

  const openConfirmPopup = () => {
    setConfirmPopup({
      show: true,
      title: "ยืนยันการบันทึก",
      message: "คุณต้องการบันทึกข้อมูลนี้หรือไม่",
    });
  };

  const closeConfirmPopup = () => {
    setConfirmPopup({
      show: false,
      title: "",
      message: "",
    });
  };

  const performSave = async () => {
    if (
      !formData.company?.trim() ||
      !formData.name?.trim() ||
      !formData.position?.trim() ||
      !formData.phone?.trim() ||
      addresses.length === 0 ||
      addresses.some((addr) => !addr.address.trim())
    ) {
      showProfilePopup({
        type: "error",
        title: "บันทึกไม่สำเร็จ",
        message: "Please fill in all fields before saving.",
      });
      return;
    }

    const isValidPhone = /^[0-9]{10}$/.test(formData.phone.trim());
    const isValidName = /^[A-Za-zก-ฮะ-์\s]+$/.test(formData.name.trim());

    if (!isValidPhone) {
      showProfilePopup({
        type: "error",
        title: "เบอร์โทรศัพท์ไม่ถูกต้อง",
        message: "Invalid phone number! It must be exactly 10 digits.",
      });
      return;
    }

    if (!isValidName) {
      showProfilePopup({
        type: "error",
        title: "ชื่อไม่ถูกต้อง",
        message: "Invalid name! It should not contain numbers.",
      });
      return;
    }

    const updatedFormData = {
      Name: formData.name.trim(),
      Email: formData.email.trim(),
      Position: formData.position.trim(),
      Addresses: addresses.filter((a) => a.address.trim() !== ""),
      Phone: formData.phone.trim(),
    };

    try {
      await axios.post("/customer/me", updatedFormData, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      const res = await axios.get("/customer/me", {
        withCredentials: true,
      });

      setProfileUser(res.data?.user || null);

      showProfilePopup({
        type: "success",
        title: "บันทึกสำเร็จ",
        message: "User details updated successfully!",
        redirectAfterClose: true,
      });
    } catch (error) {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        setNotFound(true);

        showProfilePopup({
          type: "error",
          title: "ไม่มีสิทธิ์เข้าถึง",
          message: "กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
          redirectAfterClose: true,
        });
        return;
      }

      setNotFound(true);

      showProfilePopup({
        type: "error",
        title: "เกิดข้อผิดพลาด",
        message:
          error.response?.data?.message ||
          error.response?.data?.error ||
          "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองอีกครั้ง",
        redirectAfterClose: true,
      });
    }
  };

  const handleSave = () => {
    openConfirmPopup();
  };

  const handleConfirmSave = async () => {
    closeConfirmPopup();
    await performSave();
  };

  useEffect(() => {
    if (profileUser) {
      setFormData((prev) => ({
        ...prev,
        name: profileUser.name || "",
        email: profileUser.email || "",
        company: profileUser.company || "",
        position: profileUser.position || "",
        phone: profileUser.phone || "",
      }));

      setAddresses(profileUser.addressList || []);
    }
  }, [profileUser]);

  const handleFormInputChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleFormInputUpdate = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };
  const handleFormAddressUpdate = (index, value) => {
    setAddresses((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], address: value };
      return updated;
    });
  };

  const handleRemoveAddress = (index) => {
    setAddresses((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddNewAddress = () => {
    setAddresses((prevAddresses) => [
      ...prevAddresses,
      { id: null, address: "" },
    ]);
  };
  const startEditing = () => {
    if (!profileUser) return;

    setFormData({
      name: profileUser.name || "",
      email: profileUser.email || "",
      company: profileUser.company || "",
      position: profileUser.position || "",
      phone: profileUser.phone || "",
      address: "",
    });

    setAddresses(profileUser.addressList || []);
    navigate("/customer/setting/edit");
  };

 

  useEffect(() => {
    const fetchCustomerProfile = async () => {
      try {
        const res = await axios.get("/customer/me", {
          withCredentials: true,
        });

        const profile = res.data?.user || null;

        if (!profile) {
          setNotFound(true);
          setProfileUser(null);
          return;
        }

        setProfileUser(profile);
        setNotFound(false);
      } catch (err) {
        setProfileUser(null);
        setNotFound(true);
      }
    };

    fetchCustomerProfile();
  }, []);

  return (
    <>
      <div className="setting-layout">
        <div className="setting-sidebar-fixed">
          <TicketSidebar active="/customer/setting" />
        </div>

        <div className="setting-page">
          <div className="user-info-container setting-card">
            <h2 className="user-info-title">
              {isEditPage ? "Edit User Information" : "User Infomation"}
            </h2>
            {error && <p className="user-info-error">{error}</p>}
            {notFound ? (
              <p className="user-info-loading">ไม่พบข้อมูล</p>
            ) : profileUser ? (
              <div className="user-info-details">
                {!isEditPage ? (
                  <>
                    <p className="user-info-item">
                      <strong>Name:</strong> {profileUser.name}
                    </p>
                    <p className="user-info-item">
                      <strong>Email:</strong> {profileUser.email}
                    </p>
                    <p className="user-info-item">
                      <strong>Company:</strong> {profileUser.company}
                    </p>
                    <p className="user-info-item">
                      <strong>Position:</strong> {profileUser.position}
                    </p>
                    <p className="user-info-item">
                      <strong>Phone:</strong> {profileUser.phone}
                    </p>
                    <p className="user-info-item">
                      <strong>Address:</strong>{" "}
                      {profileUser.addressString ||
                        profileUser.addressList
                          ?.map((a) => a.address)
                          .join(", ")}
                    </p>
                    <button
                      className="user-info-edit-button"
                      onClick={startEditing}
                    >
                      Edit
                    </button>
                  </>
                ) : (
                  <>
                    <div className="user-info-edit-group">
                      <label>Email:</label>
                      <input
                        type="email"
                        value={formData.email}
                        readOnly
                        className="user-info-edit-input"
                      />
                    </div>
                    <div className="user-info-edit-group">
                      <label>Company:</label>
                      <input
                        type="text"
                        value={formData.company}
                        readOnly
                        className="user-info-edit-input"
                      />
                    </div>
                    <div className="user-info-edit-group">
                      <label>Name:</label>
                      <input
                        type="text"
                        value={formData.name}
                        onChange={(e) =>
                          handleFormInputChange("name", e.target.value)
                        }
                        className="user-info-edit-input"
                      />
                    </div>
                    <div className="user-info-edit-group">
                      <label>Position:</label>
                      <input
                        type="text"
                        value={formData.position}
                        onChange={(e) =>
                          handleFormInputUpdate("position", e.target.value)
                        }
                        className="user-info-edit-input"
                      />
                    </div>
                    <div className="user-info-edit-group">
                      <label>Phone:</label>
                      <input
                        type="tel"
                        value={formData.phone}
                        onChange={(e) =>
                          handleFormInputUpdate("phone", e.target.value)
                        }
                        className="user-info-edit-input"
                      />
                    </div>
                    <div className="user-info-edit-group">
                      <label>Address:</label>
                      <div className="user-info-address-list">
                        {addresses.map((address, index) => (
                          <div key={index} className="user-info-address-item">
                            <div className="address-input-container">
                              <input
                                type="text"
                                value={address.address}
                                onChange={(e) =>
                                  handleFormAddressUpdate(index, e.target.value)
                                }
                                className="user-info-edit-input"
                                placeholder={`Address ${index + 1}`}
                              />
                              <button
                                className="remove-address-button"
                                onClick={() => handleRemoveAddress(index)}
                              >
                                Remove
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                      <button
                        className="add-address-button"
                        onClick={handleAddNewAddress}
                      >
                        Add New Address
                      </button>
                    </div>

                    <button
                      className="user-info-save-button"
                      onClick={handleSave}
                    >
                      Save
                    </button>
                    <button
                      className="user-info-cancel-button"
                      onClick={() => navigate("/customer/setting")}
                    >
                      Cancel
                    </button>
                  </>
                )}
              </div>
            ) : (
              <p className="user-info-loading">Loading user details...</p>
            )}
          </div>
        </div>
        {confirmPopup.show && (
          <div className="profile-popup-overlay">
            <div className="profile-popup-modal">
              <h3>{confirmPopup.title}</h3>

              <p>{confirmPopup.message}</p>

              <div className="profile-popup-actions">
                <button
                  type="button"
                  className="profile-popup-btn success"
                  onClick={handleConfirmSave}
                >
                  ยืนยัน
                </button>
                <button
                  type="button"
                  className="profile-popup-btn error"
                  onClick={closeConfirmPopup}
                >
                  ยกเลิก
                </button>
              </div>
            </div>
          </div>
        )}
        {profilePopup.show && (
          <div className="profile-popup-overlay">
            <div className="profile-popup-modal">
              <h3>{profilePopup.title}</h3>

              <p>{profilePopup.message}</p>

              <div className="profile-popup-actions">
                <button
                  type="button"
                  className={`profile-popup-btn ${
                    profilePopup.type === "success" ? "success" : "error"
                  }`}
                  onClick={closeProfilePopup}
                >
                  ตกลง
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Setting;
